import { call, put } from "redux-saga/effects";
import IndustryActions from "./industry-actions"
import * as api from "../../services/api"

export function* getIndustries(action) {
    const response = yield call(api.getIndustries)
    if (response.ok) {
        yield put(IndustryActions.industriesSuccess(response.data));
    } else {
        yield put(IndustryActions.industriesFailure(response.data))
    }
}

export function* createIndustry(action) {
    const { industry } = action
    const response = yield call(api.createIndustry, industry)
    if (response.ok) {
        yield put(IndustryActions.createIndustrySuccess(response.data));
    } else {
        yield put(IndustryActions.createIndustryFailure(response.data))
    }
}

export function* updateIndustry(action) {
    const { id, industry } = action
    const response = yield call(api.updateIndustry, id, industry)
    if (response.ok) {
        yield put(IndustryActions.updateIndustrySuccess(response.data));
    } else {
        yield put(IndustryActions.updateIndustryFailure(response.data))
    }
}
